import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CircleSpinnerComponent } from './circle-spinner.component';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ CircleSpinnerComponent ],
    exports: [CircleSpinnerComponent]
})

export class CircleSpinnerModule {}
